enum Environment {
    Development,
    Test,
    Production,
}

export default Environment;
